import { useState } from 'react';
import { Info } from 'lucide-react';
import { TapTipProps } from './types';

export const TapTip = ({ label, children }: TapTipProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
        className="-my-2 flex h-8 w-8 items-center justify-center text-neutral-600">
        <Info className="h-4 w-4" />
      </button>
      {open && (
        <button
          type="button"
          onClick={() => setOpen(false)}
          className="basis-full rounded-lg bg-neutral-700 px-3 py-2 text-left text-sm leading-snug text-white">
          {children}
        </button>
      )}
    </>
  );
};
